declare namespace $ {

	type $mol_svg_path__geometry_bog_vmap_app_wire_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['line_geometry'] >
		,
		ReturnType< $mol_svg_path['geometry'] >
	>
	type $mol_svg_text__pos_bog_vmap_app_wire_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['label_pos'] >
		,
		ReturnType< $mol_svg_text['pos'] >
	>
	type $mol_svg_text__text_bog_vmap_app_wire_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['label_text'] >
		,
		ReturnType< $mol_svg_text['text'] >
	>
	type $mol_svg_circle__radius_bog_vmap_app_wire_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['dot_radius'] >
		,
		ReturnType< $mol_svg_circle['radius'] >
	>
	type $mol_svg_circle__pos_bog_vmap_app_wire_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['dot_pos'] >
		,
		ReturnType< $mol_svg_circle['pos'] >
	>
	type $mol_svg_circle__attr_bog_vmap_app_wire_6 = $mol_type_enforce<
		({ 
			'bog_vmap_app_wire_dot_side': ReturnType< $bog_vmap_app_wire['dot_side'] >,
			'bog_vmap_app_wire_dot_lit': ReturnType< $bog_vmap_app_wire['dot_lit'] >,
			'bog_vmap_app_wire_dot_linked': ReturnType< $bog_vmap_app_wire['dot_linked'] >,
		})  & ReturnType< $mol_svg_circle['attr'] >
		,
		ReturnType< $mol_svg_circle['attr'] >
	>
	type $mol_svg_text__pos_bog_vmap_app_wire_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['name_pos'] >
		,
		ReturnType< $mol_svg_text['pos'] >
	>
	type $mol_svg_text__align_bog_vmap_app_wire_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['name_align'] >
		,
		ReturnType< $mol_svg_text['align'] >
	>
	type $mol_svg_text__text_bog_vmap_app_wire_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['name_text'] >
		,
		ReturnType< $mol_svg_text['text'] >
	>
	type $mol_svg_path__geometry_bog_vmap_app_wire_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_wire['drag_geometry'] >
		,
		ReturnType< $mol_svg_path['geometry'] >
	>
	export class $bog_vmap_app_wire extends $mol_svg_root {
		shapes( ): readonly($mol_view)[]
		line_geometry( id: any): string
		label_pos( id: any): readonly(number)[]
		label_text( id: any): string
		dot_radius( ): string
		dot_pos( id: any): readonly(number)[]
		dot_side( id: any): string
		dot_lit( id: any): boolean
		dot_linked( id: any): boolean
		name_pos( id: any): readonly(number)[]
		name_align( id: any): string
		name_text( id: any): string
		attr( ): ({ 
			'viewBox': any,
		})  & ReturnType< $mol_svg_root['attr'] >
		lines( ): readonly($bog_vmap_app_wire_line)[]
		dots( ): readonly($bog_vmap_app_wire_dot)[]
		drag_geometry( ): string
		sub( ): ReturnType< $bog_vmap_app_wire['shapes'] >
		Line( id: any): $mol_svg_path
		Label( id: any): $mol_svg_text
		Dot( id: any): $mol_svg_circle
		Name( id: any): $mol_svg_text
		Drag( ): $mol_svg_path
	}
	
}

//# sourceMappingURL=wire.view.tree.d.ts.map